import * as APIClient from './APIClient';

export const post = ({ eventName, data }) =>
  APIClient.post('/v1/tracking', { event_name: eventName, data });
